export const ADD_SELECTION = "ADD_SELECTION";
export const GET_SELECTIONS = "GET_SELECTIONS";
export const EDIT_SELECTION = "EDIT_SELECTION";
export const DELETE_SELECTION = "DELETE_SELECTION";
export const DELETE_SELECTIONS = "DELETE_SELECTIONS";
export const SET_SELECTION_ID = "SET_SELECTION_ID";
export const GET_SELECTION_SUBJECT = "GET_SELECTION_SUBJECT";
export const SET_SELECTION_SUBJECT = "SET_SELECTION_SUBJECT";

export const ADD_TO_CHART = "ADD_TO_CHART";
export const GET_CHART = "GET_CHART";
export const REMOVE_FROM_CHART = "REMOVE_FROM_CHART";
export const CLEAR_CHART = "CLEAR_CHART";
export const SET_ROUNDS = "SET_ROUNDS";
export const GET_ROUNDS = "GET_ROUNDS";

export const ADD_PLAYER = "ADD_PLAYER";
export const GET_PLAYERS = "GET_PLAYERS";
export const EDIT_PLAYER = "EDIT_PLAYER";
export const REMOVE_PLAYER = "REMOVE_PLAYER";
export const CLEAR_PLAYERS = "CLEAR_PLAYERS";
export const SET_PLAYER_ID = "SET_PLAYER_ID";

export const ADD_SUBMITTED_SELECTION = "ADD_SUBMITTED_SELECTIONS";
export const GET_SUBMITTED_SELECTIONS = "GET_SUBMITTED_SELECTIONS";
export const EDIT_SUBMITTED_SELECTION = "EDIT_SUBMITTED_SELECTION";
export const DELETE_SUBMITTED_SELECTION = "DELETE_SUBMITTED_SELECTION";
export const CLEAR_SUBMITTED_SELECTIONS = "CLEAR_SUBMITTED_SELECTIONS";

export const AUTH = "AUTH";
export const AUTH_START = "AUTH_START";
export const AUTH_REFRESH = "AUTH_REFRESH";
export const AUTH_UPDATE_PROFILE = "AUTH_UPDATE_PROFILE";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_FAIL = "AUTH_FAIL";

export const GET_USERS = "GET_USERS";
export const EDIT_USER = "EDIT_USER";
export const DELETE_USER = "DELETE_USER";

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";